import React from "react";

function WebDetailed() {
  return (
    <section className="relative overflow-hidden bg-[#f8f8f8] px-6 py-16 transition-colors duration-300 dark:bg-[#050505]">
      <div className="absolute left-0 top-0 h-[500px] w-[500px] rounded-full bg-primary/10 blur-[140px]" />
      <div className="absolute bottom-0 right-0 h-[500px] w-[500px] rounded-full bg-orange-300/10 blur-[140px]" />

      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(0,0,0,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.06)_1px,transparent_1px)] bg-[size:60px_60px] opacity-60 dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)]" />

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="rounded-[2rem] border border-gray-100 bg-white p-8 shadow-xl shadow-gray-500/5 dark:border-gray-800 dark:bg-[#1a1a1a] md:p-16">
          <p className="mb-3 font-semibold uppercase tracking-wide text-primary">
            Web Development Services
          </p>

          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-8">
            Professional Website Development Services for Modern Businesses
          </h2>
          <div className="text-gray-600 dark:text-gray-400 text-md space-y-6">
            <p>
              Web X Secure provides professional website development services
              designed to help businesses establish a strong online presence,
              improve customer engagement, and generate long-term growth. We
              build modern websites, web applications, SaaS platforms, and
              e-commerce solutions that are fast, secure, scalable, and
              optimized for search engines.
            </p>

            <p>
              Our development team specializes in React.js, Node.js, Express.js,
              MongoDB, PHP, WordPress, and modern frontend technologies to
              create high-performance digital experiences. Every project is
              developed using industry best practices, responsive design
              principles, and modern development standards.
            </p>

            <p>
              Whether you need a business website, corporate portal, e-commerce
              store, custom web application, CMS platform, booking system, or
              SaaS product, our experts create tailored solutions that align
              with your business goals and customer requirements.
            </p>

            <p>
              Search engine optimization, website speed optimization, security,
              mobile responsiveness, and scalability are integrated into every
              stage of the development process. This ensures better search
              visibility, improved user experience, and long-term digital
              success.
            </p>

            <p>
              From startups and local businesses to enterprises and educational
              institutions, Web X Secure delivers reliable web development
              solutions that help organizations grow faster in the digital
              world.
            </p>
            <div className="mt-10 rounded-2xl ">
              <h3 className="text-2xl font-black text-gray-900 dark:text-white mb-4">
                Explore Our Latest Resources
              </h3>

              <p className="text-gray-600 dark:text-gray-400 mb-5">
                Discover expert insights, website development guides, real-world
                case studies, web application projects, e-commerce solutions,
                and digital transformation success stories created by Web X
                Secure.
              </p>

              <ul className="space-y-3">
                <li>
                  <a
                    href="https://webxsecure.in/blog"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-primary hover:underline"
                  >
                    Website Development Blogs & Industry Insights
                  </a>
                </li>

                <li>
                  <a
                    href="https://webxsecure.in/case-study"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-primary hover:underline"
                  >
                    Web Development Case Studies & Success Stories
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDetailed;
